import { Component, OnDestroy, OnInit } from '@angular/core';
import { CurrentAdminPortalConfigService } from '@modules/common/services/current-admin-portal-config.service';
import { CurrentCaseService } from '@modules/common/services/current-case.service';
import { CustomRouteData } from '@modules/common/models/custom-route-data';
import { CurrentRouteService } from '@modules/common/services/current-route.service';
import { NavSidebarExpandedService } from '@modules/navigation/services/nav-sidebar-expanded.service';
import { CurrentPhoneCallService } from '@modules/participant-shared/services/current-phone-call.service';
import { map, Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-nav-layout',
    templateUrl: './nav-layout.component.html',
    styleUrls: ['./nav-layout.component.scss']
})
export class NavLayoutComponent implements OnInit, OnDestroy {
    public readonly showPhoneCallBanner: Observable<boolean>;

    public isNavSidebarExpanded = true;
    public clientPickerCtrStyle: any = {};
    public requiresCaseSelection?: boolean;
    public currentCaseName!: string;

    private readonly _subscriptions: Subscription[] = [];

    constructor(
        private readonly _currentAdminPortalConfigService: CurrentAdminPortalConfigService,
        private readonly _currentCaseService: CurrentCaseService,
        private readonly _currentRouteService: CurrentRouteService,
        navSidebarExpandedService: NavSidebarExpandedService,
        currentPhoneCallService: CurrentPhoneCallService,
    ) {
        const navSidebarToggleSubscription = navSidebarExpandedService.toggled.subscribe(expanded => this.isNavSidebarExpanded = expanded);
        this._subscriptions.push(navSidebarToggleSubscription);

        this.showPhoneCallBanner = currentPhoneCallService.currentPhoneCallChanged()
            .pipe(map(phoneCall => !!phoneCall));
    }

    public ngOnInit(): void {
        this.currentCaseName = this._currentCaseService.getCurrentCaseName();
        const customRouteData = this._currentRouteService.getCurrentRoute().data as CustomRouteData | undefined;
        if (customRouteData) {
            this.requiresCaseSelection = !!customRouteData.requiresCaseSelection;
        }
        const adminPortalConfigChangedSubscription = this._currentAdminPortalConfigService.configChanged.subscribe(result => {
            if (result && result.headingColor && result.headingColor.length) {
                this.clientPickerCtrStyle['background-color'] = '#' + result.headingColor;
            } else if (this.clientPickerCtrStyle.hasOwnProperty('background-color')) {
                delete this.clientPickerCtrStyle['background-color'];
            }
        });
        this._subscriptions.push(adminPortalConfigChangedSubscription);
    }

    public ngOnDestroy(): void {
        for (let subscription of this._subscriptions) {
            subscription.unsubscribe();
        }
    }
}
